import DialogTitle from './DialogTitle'

export default DialogTitle
